// Lookups against static reference tables (states, ID types, NICS responses).

import { IdTypes, NicsResponses, StateList } from '../models/constants';

export function findStateByAbbreviation(abv: string) {
  if (!abv) return undefined;
  const state = StateList.filter((st) => st.state_code === abv.toUpperCase());
  return state.length > 0 ? state[0].state_name : undefined;
}

export function getStateNamesWithPriority(
  priorityStateCode?: string,
): string[] {
  if (!priorityStateCode) {
    return StateList.map((state) => state.state_name);
  }

  const upperPriorityCode = priorityStateCode.toUpperCase();
  const priorityState = StateList.find(
    (state) => state.state_code === upperPriorityCode,
  );

  if (!priorityState) {
    return StateList.map((state) => state.state_name);
  }

  const remainingStates = StateList.filter(
    (state) => state.state_code !== upperPriorityCode,
  );

  return [
    priorityState.state_name,
    ...remainingStates.map((state) => state.state_name),
  ];
}

export function getStateNameByStateCode(
  state_code: string,
): string | undefined {
  const state = StateList.find((s) => s.state_code === state_code);
  return state ? state.state_name : undefined;
}

export function getIdTypeLabel(value: string): string | undefined {
  const type = IdTypes.find((t) => t.value === value);
  return type ? type.label : undefined;
}

export function getNicsResponseByNumber(number: number): string | undefined {
  const resp = NicsResponses.find((r) => r.number === number);
  return resp ? resp.response : undefined;
}
